
import { useState } from "react"
import { useTabla } from "../../functions/useTabla"
import { sortDirections } from "../../data/datos";
import { useEffect } from "react";
import { URL_BACKEND } from "../../api/url";

const useReporteAgrupandoMatematicas = () => {

    // variables
    const [datosReporteAlumnosMatematicas, setDatosReporteAlumnosMatematicas] = useState([])
    const [data, setData] = useState()
    const [ loading, setLoading ] = useState( true )
    const [textoBuscar, setTextoBuscar] = useState("")


    // funciones
    const traerDatosReporteAlumnoAgrupadoMatematicas = () => {

        let body = new FormData()
        body.append('funcion', 'reporteGeneralAlumnosAgrupadoMatematicas')

        fetch( URL_BACKEND, {
            body,
            method: 'post'
        })
        .then( r => r.json() )
        .then(d => {
            setDatosReporteAlumnosMatematicas( d )
            setData( d )
            setLoading( false )
        })
        // .catch(() => alert('Error en el servidor')) 
    }

    const filtrar = ( cosaABuscar ) => {

        cosaABuscar = cosaABuscar.trim()

        if (cosaABuscar) {
            // aquí haremos una búsqueda porque el usuario escribió algo
            var resultadosNuevos = data.filter( function( elemento ){
                
                let busqueda = new RegExp( cosaABuscar, 'gi' )
                if ( busqueda.test( elemento.nombre ) ) {
                    return true
                } else {
                    return false
                }

            })
            setDatosReporteAlumnosMatematicas( resultadosNuevos )

        } else {
            // aquí no haremos la búsqueda, pero devolvemos todos los elementos
            setDatosReporteAlumnosMatematicas( data )
        }
    }


    // useEffect
    useEffect(() => {
        traerDatosReporteAlumnoAgrupadoMatematicas()
    }, [])

    useEffect(() => {
      
        filtrar( textoBuscar )

    }, [ textoBuscar ])
    

    // tabla
    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'nombre',
            sorter: (a, b) => a.nombre.localeCompare(b.nombre),
            sortDirections
        },
        {
            title: 'Carrera',
            dataIndex: 'nom_carrera',
            sorter: (a, b) => a.nom_carrera.localeCompare(b.nom_carrera),
            sortDirections
        },
        {
            title: 'Expresión oral y escrita',
            dataIndex: 'pk_aspirante',
            render: (text, record) => {
                return ( <>{record.cantidad_correctas_eoye}/{record.total_eoye}</> )
                // return ( <Tag color="red">
                //     {record.cantidad_correctas_eoye}/{record.total_eoye}
                // </Tag> )
            },
            align: 'center'
        },
        {
            title: 'Matemáticas',
            dataIndex: 'pk_aspirante',
            align: 'center',
            render: (text, record) => {
                return ( <>{ record.cantidad_correctas_m }/{ record.total_m }</> )
                // return ( <Tag color="red">
                //     {record.cantidad_correctas_eoye}/{record.total_eoye}
                // </Tag> )
            },
        },
        {
            title: 'Inglés',
            dataIndex: 'pk_aspirante',
            render: (text, record) => {
                return ( <>{ record.cantidad_correctas_i }/{ record.total_i }</> )
                // return ( <Tag color="blue">
                //     {record.cantidad_correctas_i}/{record.total_i}
                // </Tag> )
            },
            align: 'center'
        }
    ];

    return {
        datosReporteAlumnosMatematicas,
        columns,
        loading,
        textoBuscar,
        setTextoBuscar
    }
}

export default useReporteAgrupandoMatematicas
